/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable no-dupe-keys */
import React from "react";
// import { Link, useLocation } from "react-router-dom";
import bg from "../img/bg.png";
import notfound from "../img/notfound.jpg"
import Form from "react-bootstrap/Form";
export default function Notfound404({ text }) {
  // const { state } = useLocation();

  return (
    <>
      <Form>
        <div className="App login-box">
          <section
            style={{
              backgroundImage: `url(${bg})`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "100% 100%",
              backgroundSize: "cover",
              minHeight: "1180px"
            }}
          >
            <div className="">
              <div className="d-flex align-items-center justify-content-center vh-100" >
            
                <div className="text-center row pb-4 rounded justify-content-center align-items-center" style={{ backgroundColor: "white", height: "70%", maxHeight: "450px" }}>
               
                  <div className="col-md-6 ">
                    <img src={notfound}
                      className="img-fluid" style={{ maxHeight: "220px" }} />
                  </div>
                  <div className=" col-md-6 mt-5">
                    <p className="fs-3"> <span className="text-danger">Opps!</span> Page not found.</p>
                    <p className="lead" style={{ fontSize: '16px' }}>
                      {text}                     
                    </p>
                    <div className="mb-3">
                      <a href="/PageLogin" className="btn btn-primary">คลิกเพื่อกลับไปหน้า Login <br/>ระบบทดสอบสมรรถภาพทางกายกำลังพลทหารอากาศ</a>
                      </div>

                  </div>

                </div>
              </div>
            </div>
          </section>
        </div>

      </Form>
      {/* <button variant="contained"> <a href="/">Back HomePage {text}</a></button> */}
    </>
    // <Box
    //   sx={{
    //     display: "flex",
    //     justifyContent: "center",
    //     alignItems: "center",
    //     minHeight: "100vh",
    //   }}
    // >
    //   <Container maxWidth="md">
    //     <Grid container spacing={2}>
    //       <Grid xs={6}>
    //         <Typography variant="h1">{state === null || state?.statusCode === 404 ? "404" : state?.statusCode }</Typography>
    //         <Typography variant="h6">
    //             {text || state.txt}
    //        </Typography>
    //         <Link to={"/"}>
    //           <Button variant="contained">Back HomePage</Button>
    //         </Link>
    //       </Grid>
    //       <Grid xs={6}>
    //         <img
    //           src={state === null || state?.statusCode === 404 ? "https://cdn.pixabay.com/photo/2017/03/09/12/31/error-2129569__340.jpg": "https://www.ionos.com/digitalguide/fileadmin/DigitalGuide/Teaser/401-Unauthorized-t.jpg"}
    //           alt=""
    //           width={500}
    //           height={250}
    //         />
    //       </Grid>
    //     </Grid>
    //   </Container>
    // </Box>
  );
}